import { Component, Vue, Watch, Prop } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTrashAlt,
	faPlusCircle,
	faExternalLinkAlt,
	faEdit,
	faPlus,
	faMinus,
	faFilePdf,
	faCopy,
} from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'
import FieldPortal from '@/components/edit/FieldPortal/index.vue'
import MessageError from '@/components/edit/MessageError/index.vue'
import ManageArray from '@/components/edit/ManageArray/index.vue'
import MessageErrorAlert from '@/components/edit/MessageErrorAlert/index.vue'
import MessageSuccess from '@/components/edit/MessageSuccess/index.vue'
import TableTrialDetailAdministrative from '@/views/GroupsDetail/TableTrialDetailAdministrative/index.vue'

import InputPortal from '@/components/edit/InputPortal/index.vue'

import { validationMixin } from 'vuelidate'
import { minLength } from 'vuelidate/lib/validators'

import Control from '@/helpers/control'
import api from '@/helpers/fetch'
import { Validations } from 'vuelidate-property-decorators'
import vSelect from 'vue-select'

import { bus } from '@/main'

library.add(
	faTrashAlt,
	faPlusCircle,
	faExternalLinkAlt,
	faEdit,
	faPlus,
	faMinus,
	faFilePdf,
	faCopy,
)

Vue.component('v-select', vSelect)

@Component({
	components: {
		Loader,
		MessageError,
		MessageSuccess,
		FieldPortal,
		MessageErrorAlert,
		TableTrialDetailAdministrative,
		InputPortal,
		ManageArray,
	},
	mixins: [validationMixin],
})
export default class Administrative extends Vue {
	@Prop({ default: () => [], type: Array }) users
	group: any | null = null
	administrative: any | null = null

	control = new Control()

	loadingTrial = false
	saving = false
	success = false
	error = ''
	lastSaveDate: Date | null = null
	selectedTrialId = 0
	currentMainTrialId = 0
	view: null | string = null

	diff: null | any[] = null
	diffData: null | any
	blockedDiff = false
	blockRemetente = false

	totalAdded = 0
	totalRemoved = 0

	newProcessNumber = ''
	loadingNewProcessNumber = false
	errorDuplicateProcessNumber = false
	messageError = ''

	sitDate = ''

	updatingAllDates = false
	updatingAllDatesResult = null

	court_costs_to_key = 0

	clientFilter = null

	fieldsMonthsLabels = {
		reportSendingOnJan: 'Janeiro',
		reportSendingOnFeb: 'Fevereiro',
		reportSendingOnMar: 'Março',
		reportSendingOnApr: 'Abril',
		reportSendingOnMay: 'Maio',
		reportSendingOnJun: 'Junho',
		reportSendingOnJul: 'Julho',
		reportSendingOnAug: 'Agosto',
		reportSendingOnSep: 'Setembro',
		reportSendingOnOct: 'Outubro',
		reportSendingOnNov: 'Novembro',
		reportSendingOnDec: 'Dezembro',
	}

	async mounted() {
		if (this.$route.params.clientId) {
			await this.fetchClientDetail()
		}
		if (!this.administrative.court_costs_type) {
			this.administrative.court_costs_type = 'Pagamento externo'
			this.duplicateReportSendingTo()
		}

		const res = await api.get(
			'/api/groups/' +
				this.$route.params.clientId +
				'/open-email-logs?is_adm=true',
		)
		if (res.ok) {
			if (res.data.length) {
				this.blockRemetente = true
			}
		}

		this.$emit('updateAdmReportType', this.administrative.reportType)
		this.loadCheckedTrials()
	}

	get totalTrials() {
		return this.filteredTrials.filter(
			(relation) =>
				relation.trialAdm &&
				!relation.trialAdm.closed &&
				!relation.trialAdm.mainTrial,
		).length
	}

	get filteredTrials() {
		if (this.clientFilter === null) {
			return this.group.groupsRelations
		} else {
			return this.group.groupsRelations.filter((item) => {
				for (let i = 0; i < item.trialAdm.clients.length; i++) {
					if (
						item.trialAdm.clients[i].client.CNPJOrCPF ===
						this.clientFilter
					) {
						return true
					}
				}

				return false
			})
		}
	}

	copy(processNumber): void {
		navigator.clipboard.writeText(processNumber)

		this.$bvToast.toast('Número do processo copiado!', {
			title: 'Sucesso!',
			variant: 'success',
			noCloseButton: true,
			noAutoHide: false,
			toaster: 'b-toaster-top-center',
		})
	}

	updatePDF() {
		bus.$emit('loadPDF', 'Administrativo')
	}

	duplicateReportSendingTo() {
		if (
			!this.administrative.reportSendingTo ||
			!Array.isArray(this.administrative.reportSendingTo)
		) {
			return
		}

		if (
			!this.administrative.court_costs_to ||
			!Array.isArray(this.administrative.court_costs_to)
		) {
			this.administrative.court_costs_to = []
		}

		const reportSendingToCopy = [...this.administrative.reportSendingTo]

		reportSendingToCopy.forEach((email) => {
			if (!this.administrative.court_costs_to.includes(email)) {
				this.administrative.court_costs_to.push(email)
			}
		})

		this.onUpdate(
			this.administrative.court_costs_to,
			'court_costs_to',
			'court_costs_to',
			'array',
		)
		this.court_costs_to_key++
	}

	@Watch('newProcessNumber')
	onChange(processNumber) {
		this.messageError = ''
		const debouncedChange = this.control.debounce(() => {
			this.createNewTrial(processNumber)
		}, 1000)
		debouncedChange()
	}

	@Validations()
	validations() {
		return {
			newProcessNumber: {},
		}
	}

	async fetchClientDetail() {
		this.$store.dispatch('saveCurrentFullPath', this.$route.fullPath)

		const res = await api.get(
			'/api/groups-adm/' + this.$route.params.clientId,
		)

		const resClients = await api.get(
			'/api/groups/' + this.$route.params.clientId + '/clients',
		)

		resClients.data.forEach((client) => {
			const cnpj = client?.CNPJOrCPF?.replace(
				/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
				'$1.$2.$3/$4-$5',
			)

			client.name = cnpj + ' - ' + client.name
		})

		res.data.clients = [
			{ id: null, name: 'Sem Filtro', CNPJOrCPF: null },
			...resClients.data,
		]
		if (!res.ok) {
			return
		}

		this.group = { ...res.data }

		if (res.data.administrative) {
			if (typeof res.data.administrative.court_costs_to === 'string') {
				try {
					this.administrative = {
						...res.data.administrative,
						court_costs_to: JSON.parse(
							res.data.administrative.court_costs_to,
						),
					}
				} catch (error) {
					console.error(
						'Erro ao converter court_costs_to para array',
						error,
					)
					this.administrative = {
						...res.data.administrative,
						court_costs_to:
							res.data.administrative.court_costs_to.split(','),
					}
				}
			} else {
				this.administrative = { ...res.data.administrative }
			}
		}
	}

	async createNewTrial(processNumber) {
		this.loadingNewProcessNumber = true
		this.errorDuplicateProcessNumber = false

		const groupId = this.$route.params.clientId

		const res = await api.post('/api/trial-new-adm', {
			processNumber,
			group_id: groupId,
		})

		if (res?.ok) {
			this.loadingNewProcessNumber = false
			await this.fetchClientDetail()
		}
	}

	async onUpdate(array, ref, prop, formatType = 'array') {
		if (array) {
			this.administrative[prop] = array
			const manageArrayComponent = this.$refs[ref] as any
			manageArrayComponent.setLoading(true)
			const submit =
				formatType === 'object'
					? `{${array.map((item) => `"${item}"`).join(',')}}` // Formato objeto
					: `[${array.map((item) => `"${item}"`).join(', ')}]` // Formato array

			const res = await api.put(
				'/api/groups-adm/' + parseInt(this.$route.params.clientId, 10),
				{ [prop]: submit },
			)

			if (res.ok) {
				manageArrayComponent.setLoading(false)
				manageArrayComponent.setSuccess(true)
				manageArrayComponent.start()
			}
		}
	}

	onInputReportSendingFrom(userId) {
		this.onInput('reportSendingFrom', userId)
	}

	onInputElaborator(userId) {
		this.onInput('elaborator', userId)
	}

	onInputReviewer(userId) {
		this.onInput('reviewer', userId)
	}

	onInput(name, value) {
		const debouncedChange = this.control.debounce(() => {
			this.save(name, value)
		}, 1000)
		debouncedChange()
	}

	async save(name, value) {
		this.saving = true
		this.$emit('passSuccessToGrandparent', false, this.saving, null)

		const newGroup = {}
		newGroup[name] = value

		if (name === 'reportSendingFrom') {
			await api.put(
				'/api/groups/' + parseInt(this.$route.params.clientId, 10),
				newGroup,
			)
		}

		const result = await api.put(
			'/api/groups-adm/' + parseInt(this.$route.params.clientId, 10),
			newGroup,
		)

		this.saving = false

		if (result.ok) {
			this.success = true
			this.lastSaveDate = new Date()
			this.$emit(
				'passSuccessToGrandparent',
				this.success,
				this.saving,
				this.lastSaveDate,
			)

			if (name === 'reportType') {
				this.$emit('updateAdmReportType', value)
			}
		} else {
			this.error = result.msg
		}
	}

	openTrial(trial) {
		if (this.selectedTrialId === trial.id) {
			this.selectedTrialId = 0
			this.currentMainTrialId = 0
			this.updatePDF()
		} else {
			this.selectedTrialId = 0
			this.$nextTick(() => {
				this.currentMainTrialId = trial.mainTrial?.id
				this.selectedTrialId = trial.id
				trial.loading = true
				this.updatePDF()
			})
		}
	}

	async onSuccess($event) {
		this.success = $event
		this.lastSaveDate = new Date()
		this.$emit(
			'passSuccessToGrandparent',
			this.success,
			false,
			this.lastSaveDate,
		)
		bus.$emit('fetchDiff')
	}

	async updateAllDates(date) {
		const trialsToModify: any[] = []

		if (this?.group?.groupsRelations) {
			this.group.groupsRelations.forEach((t) => {
				trialsToModify.push({
					id: t.trialAdm.id,
					currentSituationDate: date,
				})
			})
		}

		this.updatingAllDates = true
		this.updatingAllDatesResult = null

		const result = await api.put(
			'/api/trials-adm/0/current-situation',
			trialsToModify,
		)

		this.updatingAllDates = false
		this.updatingAllDatesResult = result
	}

	get storageKey() {
		return `adm-checklist-${this.$route.params.clientId}`
	}

	get allTrialsChecked() {
		return (
			!!this.group?.groupsRelations?.length &&
			this.group.groupsRelations.every((t) => !!t.trialAdm.checked)
		)
	}

	loadCheckedTrials() {
		const currentKey = this.storageKey

		const raw = localStorage.getItem(currentKey)
		const checkedIds = new Set<number>()
		if (raw) {
			const saved: Array<{ id: number; checked: boolean }> =
				JSON.parse(raw)
			saved.forEach((item) => {
				if (item.checked) checkedIds.add(item.id)
			})
		}

		this.group.groupsRelations.forEach((t) => {
			this.$set(t.trialAdm, 'checked', checkedIds.has(t.trialAdm.id))
		})
	}

	saveCheckedTrials() {
		const data = this.group.groupsRelations.map((t) => ({
			id: t.trialAdm.id,
			checked: !!t.trialAdm.checked,
		}))
		localStorage.setItem(this.storageKey, JSON.stringify(data))
	}

	toggleAllTrials() {
		const allChecked = this.allTrialsChecked
		this.group.groupsRelations.forEach((t) => {
			this.$set(t.trialAdm, 'checked', !allChecked)
		})
		this.saveCheckedTrials()
	}

	getPdfUrl() {
		let host = ''
		let protocol = ''
		let url = '/api/relatorio-adm/' + this.$route.params.clientId
		if (window.location.hostname === 'localhost') {
			host = 'localhost:8734'
			protocol = 'http://'
		}

		if (this.clientFilter) {
			url =
				'/api/groups-adm/' +
				this.$route.params.clientId +
				'/clients/report?cnpj=' +
				this.clientFilter
		}

		if (this.selectedTrialId) {
			url =
				'/api/trials-adm/' +
				(this.currentMainTrialId || this.selectedTrialId) +
				'/report/'
		}

		return protocol + host + url
	}
}
